export const COLORS = {
  red: '#ff6384',
  orange: '#ff9f40',
  yellow: '#ffce56',
  green: '#4bc0c0',
  blue: '#36a2eb',
  purple: '#cc65fe',
  grey: '#c9cbcf',
};
